export default __webpack_public_path__ + "static/media/sofa.2ecd4d18.png";